export default function Divider({ height='1', fill="#DEE2FB", className = "" }) {
  return (
    <hr
      className={`m-0 border-none p-0 ${className}`}
      style={{
        height: `${height}px`,
        background: `${fill}`,
      }}
    />
  );
}
